import React, { useState } from "react";
import { CustomizationCarousel } from "./common/CustomizationCarousel";
import { MiniQRPreview } from "./MiniQRPreview";
import { ColorPickerWithPresets } from './common/ColorPickerWithPresets';
import { AdvancedSettings } from './common/AdvancedSettings';
import { Frame } from '../types';
import styled from 'styled-components';

interface FrameCustomizationProps {
  frame: string | Frame;
  setFrame: (frame: string | Frame) => void;
  frameColor: string;
  setFrameColor: (color: string) => void;
  frameThickness: number;
  setFrameThickness: (thickness: number) => void;
  shape: string;
  currentFramePage: number;
  setCurrentFramePage: (page: number) => void;
  markerStyle: string;
  markerColor: string;
}

interface FrameOption {
  value: string | { type: string };
  label: string;
}

export const FrameCustomization: React.FC<FrameCustomizationProps> = ({
  frame,
  setFrame,
  frameColor,
  setFrameColor,
  frameThickness,
  setFrameThickness,
  shape,
  markerStyle,
  markerColor,
}) => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const frameOptions: FrameOption[] = [
    { value: 'none', label: 'No Frame' },
    { value: 'simple', label: 'Simple' },
    { value: 'rounded', label: 'Rounded' },
    { value: 'fancy', label: 'Fancy' },
    // { value: 'chat', label: 'Chat' },
    // { value: { type: 'colorful' }, label: 'Colorful' },
  ];

  const itemsPerPage = 6;
  const totalPages = Math.ceil(frameOptions.length / itemsPerPage);

  return (
    <Section>
      <CustomizationCarousel
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
      >
        {frameOptions
          .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
          .map((option) => (
            <OptionBox
              key={typeof option.value === "string" ? option.value : option.value.type}
              active={
                frame === option.value ||
                (typeof frame === "object" &&
                  "type" in frame &&
                  typeof option.value === "object" &&
                  "type" in option.value &&
                  frame.type === option.value.type)
              }
              onClick={() =>
                setFrame(
                  typeof option.value === "object"
                    ? { type: "colorful" }
                    : option.value
                )
              }
            >
              <PreviewContainer>
                <MiniQRPreview
                  frame={option.value}
                  frameColor={frameColor}
                  frameThickness={frameThickness}
                  shape={shape}
                  markerShape={markerStyle}
                  markerStyle={markerStyle}
                  markerColor={markerColor}
                  cornerDotStyle={markerStyle}
                  cornerDotColor={markerColor}
                />
              </PreviewContainer>
              <OptionLabel>{option.label}</OptionLabel>
            </OptionBox>
          ))}
      </CustomizationCarousel>

      <AdvancedSettings
  showAdvanced={showAdvanced}
  setShowAdvanced={setShowAdvanced}
  titlePrefix="Advanced Frame"
>

        <ColorPickerWithPresets
          label="Frame Color"
          color={frameColor}
          onChange={setFrameColor}
        />
        <ThicknessInput>
          <label>Frame Thickness</label>
          <input
            type="number"
            min={1}
            max={20}
            value={frameThickness}
            onChange={(e) => setFrameThickness(parseInt(e.target.value))}
          />
        </ThicknessInput>
      </AdvancedSettings>
    </Section>
  );
};

const Section = styled.section`
  margin-top: 24px;
`;

const OptionBox = styled.button<{ active: boolean }>`
  min-width: 120px;
  height: 120px;
  background: white;
  border: 2px solid ${props => props.active ? '#ff6320' : '#e9ecef'};
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  &:hover {
    border-color: #ff6320;
  }
`;

const PreviewContainer = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OptionLabel = styled.span`
  font-size: 12px;
  color: #666;
  text-align: center;
`;

const ThicknessInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 14px;
    color: #666;
  }

  input {
    padding: 8px;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    font-size: 14px;
  }
`;
